import React from 'react';

const ImageViewBeta = () => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '2rem'
    }}>
      <p>Image View Coming Soon...</p>
    </div>
  );
};

export default ImageViewBeta;
